/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Bulk_TargetInputs */

const en_portal_goal_bulk_target = /** @type {(inputs: Portal_Goal_Bulk_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+0.25 kg a week, lean`)
};

const pl_portal_goal_bulk_target = /** @type {(inputs: Portal_Goal_Bulk_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+0,25 kg tygodniowo, bez tłuszczu na zapas`)
};

/**
* | output |
* | --- |
* | "+0.25 kg a week, lean" |
*
* @param {Portal_Goal_Bulk_TargetInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_bulk_target = /** @type {((inputs?: Portal_Goal_Bulk_TargetInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Bulk_TargetInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_bulk_target(inputs)
	return en_portal_goal_bulk_target(inputs)
});